import styled, { css } from 'styled-components';

export type ModeProps = {
  $mode: 'horizontal' | 'vertical';
};

export const ImageLabel = styled.div(
  ({ theme }) => css`
    position: absolute;
    bottom: 0;
    left: 0;
    padding-top: ${theme.sz.s1};
    padding-bottom: ${theme.sz.s1};
    padding-left: ${theme.sz.s2};
    padding-right: ${theme.sz.s2};
    background-color: ${theme.co.primary98};
    border-top-right-radius: ${theme.bo.mediumSmall};
    color: ${theme.co.neutral0};
    font-family: ${theme.DEPRECATED_ty.openSans};
    font-size: 7px;
    font-weight: ${theme.DEPRECATED_ty.bold};
    line-height: ${theme.DEPRECATED_ty.smallest};

    @media (min-width: ${theme.sz.md}) {
      border-top-right-radius: ${theme.bo.mediumLarger};
      padding-top: ${theme.sz.s2};
      padding-bottom: ${theme.sz.s2};
      padding-left: ${theme.sz.s4};
      padding-right: ${theme.sz.s4};
      font-size: ${theme.DEPRECATED_ty.medium};
      line-height: ${theme.DEPRECATED_ty.larger};
    }
  `,
);

export const ImageWrapper = styled.div<ModeProps>(
  ({ theme, $mode }) => css`
    display: flex;
    flex-direction: row;
    position: relative;
    width: 100%;
    aspect-ratio: 4/3;
    border-radius: ${theme.bo.mediumSmall};
    margin-bottom: ${theme.sz.s4};
    overflow: hidden;

    ${
      $mode === 'horizontal' &&
      css`
        aspect-ratio: 137/148;
        max-width: 274px;
      `
    };

    @media (min-width: ${theme.sz.md}) {
      margin-bottom: ${theme.sz.s8};
      border-radius: ${theme.bo.medium};

      ${
        $mode === 'horizontal' &&
        css`
          margin: ${theme.sz.s0};
        `
      };
    }
  `,
);

export const MissionCard = styled.div<ModeProps>(
  ({ theme, $mode }) => css`
    width: 100%;
    padding-top: ${theme.sz.s6};
    padding-bottom: ${theme.sz.s10};
    padding-left: ${theme.sz.s4};
    padding-right: ${theme.sz.s4};
    border-color: ${theme.co.secondary20};
    border-radius: ${theme.bo.mediumLarger};
    border-style: solid;
    border-width: 3px;

    ${
      $mode === 'horizontal' &&
      css`
        display: flex;
      `
    };

    @media (min-width: ${theme.sz.md}) {
      padding-left: ${theme.sz.s6};
      padding-right: ${theme.sz.s6};
    }
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s4};
    color: ${theme.co.primary99};
    font-family: ${theme.DEPRECATED_ty.openSans};
    font-size: ${theme.DEPRECATED_ty.large};
    font-weight: ${theme.DEPRECATED_ty.bold};
    line-height: 130%;
    /* or 26px */

    @media (min-width: ${theme.sz.md}) {
      margin-bottom: ${theme.sz.s8};
      font-size: ${theme.DEPRECATED_ty.larger};
      line-height: 130%;
      /* or 31px */
    }
  `,
);

export const CallToActionWrapper = styled.div<ModeProps>(
  ({ theme, $mode }) => css`
    ${
      $mode === 'horizontal' &&
      css`
        padding-left: ${theme.sz.s6};
        align-self: center;
      `
    };
  `,
);
